import styled from "@emotion/styled";
import {ReactComponent as svgLightGreenGraph} from "../../../../images/800CallLogs/Resources for Call Logs/GraphYellowGreen.svg"

export const GraphLightGreenSvg = styled(svgLightGreenGraph)`
     width: 38px;
     height: 38px;
`;